import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { EMAIL_REGEX } from 'globals/helpers/constants';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { AccountsService } from 'src/app/services/accounts.service';
import { UiService } from 'src/app/services/ui.service';

@Component({
    selector: 'invite-user-dialog',
    template: `
<div class="invite_user_dialog joi-dialog">
  <div mat-dialog-content>
      <form #inviteForm="ngForm">
          <mat-form-field class="general">
              <input matInput name="email" type="email"
              [pattern]="EMAIL_REGEX" (change)="guessNameFromEmail()" [(ngModel)]="user.email" placeholder="Email" required>
          </mat-form-field>
          <div *ngIf="errorMessage" class="errorMessage">
              <icon (click)="errorMessage = null" class="close" matIcon="close"></icon>
              <div>{{errorMessage}}</div>
          </div>
          <mat-form-field class="general">
              <input matInput name="firstName" [(ngModel)]="user.firstName" placeholder="First name" required>
          </mat-form-field>
          <mat-form-field class="general">
              <input matInput name="lastName" [(ngModel)]="user.lastName" placeholder="Last name" required>
          </mat-form-field>
          <mat-radio-group name="role" class="role_group" [(ngModel)]="user.role" required>
              <mat-radio-button class="role" color="primary" *ngFor="let role of accountService.roles" [value]="role.value" [disabled]="role.disabled">
                <div class="label">{{role.label}}</div>
                <ul>
                  <li class="desc" *ngFor="let desc of role.desc">{{desc}}</li>
                </ul>
              </mat-radio-button>
          </mat-radio-group>
      </form>
  </div>
  <div mat-dialog-actions>
      <button mat-button (click)="dialogRef.close()">CANCEL</button>
      <button mat-button color="primary" [disabled]="inviteForm.invalid || errorMessage" (click)="dialogRef.close(user)">INVITE</button>
  </div>
</div>
  `,
    styleUrls: ['./accounts.dialog.inviteUser.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatRadioModule, CommonModule, FormsModule, IconComponent],
})
export class InviteUserDialogComponent {

  EMAIL_REGEX = EMAIL_REGEX
  account;
  roles
  errorMessage;
  user: any = { email: '', firstName: '', lastName: '', role: 'event', status: 'sending' };

  constructor(public dialogRef: MatDialogRef<InviteUserDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public accountService: AccountsService, public ui: UiService) {
    this.account = data.acc;
    this.roles = [...this.accountService.roles]
    if (!this.account.is_admin) {
      const admin_role = this.roles.find(r => r.value === 'admin');
      admin_role['disabled'] = true;
      if (!this.account.is_exec) {
        const exec_role = this.roles.find(r => r.value === 'executive');
        exec_role['disabled'] = true;
      }
    }
  }

  isExistingAccountUser(email){
    // console.log('this.account.users ', this.account, email);
    const userInfo = this.account.userInfo.find(u=>u.email === email)
    // console.log('userInfo ', userInfo);
    if(userInfo && this.account.users.includes(userInfo.uid)) {
      this.errorMessage = 'This user is already an account member'
      return true;
    }
  }

  guessNameFromEmail() {
    const email = this.user.email;
    if( this.isExistingAccountUser(email) ) return;
    this.errorMessage = null;
    const full_name = email.split('@')[0];
    if (!full_name) return;
    const name_bits = full_name.split(/[._-\d+]{1,}/g);
    for (let i = name_bits.length - 1; i > 0; i--) {
      if (name_bits[i] === "") { name_bits.pop(); }
    }
    if (!this.user.firstName) this.user.firstName = this.ui.jsUcfirst(name_bits[0]);
    if (!this.user.lastName) this.user.lastName = (name_bits.length > 1) ? this.ui.jsUcfirst(name_bits[name_bits.length - 1]) : '';
  }
}
// todo: for both of these we need to disable the ability for users to give more access than they have themselves
